import {UndoableAction} from "./UndoableAction";

export class UndoableActionGroup implements UndoableAction {
    actions: UndoableAction[] = [];
    dontWaitDBToExecute: boolean = false;
    afterCb: (() => void)[] = [];

    addAction(undoableAction: UndoableAction) {
        this.actions.push(undoableAction);
    }

    add(undoableAction: UndoableAction) {
        this.addAction(undoableAction);
        return undoableAction.execute();
    }

    execute(): Promise<any> {
        let finishPromise: Promise<any>;
        if (this.dontWaitDBToExecute) {
            let dbQueries = [];
            for (const action of this.actions) {
                dbQueries.push(action.execute());
            }
            finishPromise = Promise.all(dbQueries);
        } else {
            let executionQueue = Promise.resolve();
            for (const action of this.actions) {
                executionQueue = executionQueue.then(() => action.execute());
            }
            finishPromise = executionQueue;
        }
        finishPromise = finishPromise.then(() => {
            for (const cb of this.afterCb) {
                cb();
            }
        })
        return  finishPromise;
    }

    undo(): Promise<any> {
        let executionQueue = Promise.resolve();
        for (const action of this.actions.slice().reverse()) {
            executionQueue = executionQueue.then(() => action.undo());
        }
        return executionQueue;
    }

    after(cb: () => void) {
        this.afterCb.push(cb);
    }
}
